/*
 * Module for the Annual COLA Communication criteria page
 */
rs.module("content/jobs/criteria/annualcolacommunication",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, deliveryOptions, availablePrinters, preferredPrinter) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var skipReviewCheckBox = criteria.js(jsSelectors.skipReviewCheckBox);
            var deliveryMethodSelect = criteria.js(jsSelectors.deliveryMethodSelect);
            var printersSelect = criteria.js(jsSelectors.printersSelect);

            // Get Select Helper(s) to update the options and properties.
            var deliveryMethodSelectHelper = selectHelper.getHelper(deliveryMethodSelect);
            var printersSelectHelper = selectHelper.getHelper(printersSelect);

            // disable the printers dropdown based on the skip Review check box
            skipReviewCheckBox.change(function () {
                enableDisableSkipReviewFields();
            });

            // Enable or disable fields related to the skip review flag
            function enableDisableSkipReviewFields() {

                if (skipReviewCheckBox.is(":checked")) {

                    //enable and re-populate delivery method select
                    deliveryMethodSelectHelper.setDisabled(false);
                    deliveryMethodSelectHelper.replaceOptions(deliveryOptions);

                    //enable and re-populate printer select
                    printersSelectHelper.setDisabled(false);
                    printersSelectHelper.replaceOptions(availablePrinters);

                    // Since we have reloaded options, we should again default to the user's preferred Printer
                    if (preferredPrinter != '') {
                        printersSelectHelper.setValue(preferredPrinter);
                    }
                }
                else {
                    //disable and clear delivery method select
                    deliveryMethodSelectHelper.clearOptions();
                    deliveryMethodSelectHelper.setDisabled(true);

                    //disable and clear printer select
                    printersSelectHelper.clearOptions();
                    printersSelectHelper.setDisabled(true);
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);